import { toBranchDisplayName } from './branchNames';

const APP_NAME = process.env.REACT_APP_APP_NAME || 'PizzaHub';
const BRANCH_NAME = toBranchDisplayName({
  branchId: Number(process.env.REACT_APP_BRANCH_ID || 0),
  branchName: process.env.REACT_APP_BRANCH_NAME || 'Arugam Bay 1',
  branchCode: process.env.REACT_APP_BRANCH_CODE || '',
});
const APP_TITLE = (process.env.REACT_APP_APP_TITLE || `${APP_NAME} ${BRANCH_NAME}`).trim();
const PAYMENT_ACCOUNT_NAME = process.env.REACT_APP_PAYMENT_ACCOUNT_NAME || APP_NAME;

const BRAND_INITIALS = (APP_TITLE || APP_NAME)
  .split(/\s+/)
  .filter(Boolean)
  .slice(0, 2)
  .map((w) => w[0].toUpperCase())
  .join('') || 'PH';

export {
  APP_NAME,
  BRANCH_NAME,
  APP_TITLE,
  PAYMENT_ACCOUNT_NAME,
  BRAND_INITIALS,
};
